<template>
    <v-btn-toggle v-model="query.state" tile color="secondary" @change="setQuery">
        <v-btn v-for="{ text, value } in items" :key="text" v-bind="{ value }">{{ text }}</v-btn>
    </v-btn-toggle>
</template>

<script>
import { attrs_input, FORM_STATES__POINT_ORDER_ACCOUNT } from "@/assets/variables";

import ListSearch from "@/components/console/dumb/list-search.vue";

let initQuery = (query = {}) => ({
    ...query,
    ["state"]: query?.["state"] || null,
});

const items = [{ text: "전체", value: null }].concat(Object.values(FORM_STATES__POINT_ORDER_ACCOUNT));

export default {
    components: {
        ListSearch,
    },
    props: {
        showsSearch: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        items,

        attrs_input,
    }),
    mounted() {
        this.sync();
    },

    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        setQuery() {
            const { ...query } = this.$route.query || {};

            query.state = this.query.state;
            if (!query.state) delete query.state;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
